const generateId = (prefix = 'el') =>
  `${prefix}-${Date.now()}-${Math.floor(Math.random() * 1000)}`;

export const cloneElementsWithOffset = (elements, offset) => (
  elements.map((el, index) => ({
    ...el,
    id: generateId(el.type || `el${index}`),
    x: (el.x || 0) + offset,
    y: (el.y || 0) + offset,
    locked: false,
    zIndex: (el.zIndex || 0) + 1,
  }))
);

export const normalizeClipboard = (elements) => (
  elements.map((el) => ({ ...el }))
);
